/* eslint-disable max-lines */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import axios from 'axios'
import styled from 'styled-components'
import ReferralCode from './referralCode'
import constants from '../../../constants/constants'
import styles from '../../../constants/styles'
import colors from '../../../constants/colors'
import * as actions from '../../../actions'
import Auth from '../../../lib/Auth'

import {
  Username,
  FormInputUnavailable,
  FormInputAvailable
} from '../icons/Form'
import { PageLoadingCircularProgress } from '../icons/CircularProgress'

class Signup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // to show second screen or not
      email: '',
      password: '',
      hidePassword: true,
      accessToken: '',
      name: '',
      username: '',
      location: '',
      errors: {
        email: '',
        password: '',
        username: '',
        identity: ''
      },
      focus: {
        email: '',
        password: '',
        username: '',
        identity: ''
      },
      loading: false,
      usernameChecked: 'checking'
    }
    this.containerRef = null
    this.toggleShowPassword = this.toggleShowPassword.bind(this)
    this.validateErrors = this.validateErrors.bind(this)
    this.checkForExistingEmail = this.checkForExistingEmail.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
  }

  toggleShowPassword() {
    const { hidePassword } = this.state
    this.setState({ hidePassword: !hidePassword })
  }

  handleChange(category, value) {
    // TODO fix
    // eslint-disable-next-line prefer-object-spread
    const obj = Object.assign({}, this.state)
    obj[category] = value
    obj.errors = {
      email: '',
      password: ''
    }
    this.setState(obj)
  }

  handleLogin(step) {
    const { setNextStep } = this.props
    setNextStep(step)
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  validateErrors() {
    const { email, password, accessToken, username } = this.state
    const obj = this.state.errors
    let errors = false

    if (!email) {
      obj.email = 'Your email is required'
      errors = true
    }
    if (
      email &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      obj.email = 'That email is invalid'
      errors = true
    }
    if (!password && !accessToken) {
      obj.password = 'Your password is required'
      errors = true
    }
    if (password.length < 8) {
      obj.password = 'Minimum 8 characters'
      errors = true
    }
    if (password.length > 99) {
      obj.password = 'Maximum 99 characters'
      errors = true
    }
    if (!username) {
      obj.username = 'Please choose a username'
      errors = true
    }
    if (username && !/^[a-z0-9-]{1,20}$/.test(username)) {
      obj.username = 'Up to 20 lowercase letters and numbers only'
      errors = true
    }

    this.setState({ errors: obj })
    return errors
  }

  checkForExistingEmail() {
    const { email, errors } = this.state
    this.setState({ loading: true })
    axios
      .get(`${constants.api.auth.check}email/${email}`)
      .then((res) => {
        this.setState({ loading: false })
        if (res.data) {
          const obj = {
            ...errors,
            email: 'This email address is already taken'
          }
          this.setState({ errors: obj })
        }
      })
      .catch((err) => {
        this.setState({ loading: false })
        console.error(err)
        // TODO fix
        // eslint-disable-next-line no-alert
        window.alert(
          'There was a problem validating your email address. Please try again.'
        )
      })
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity
  handleSubmit(e) {
    const { setNextStep, updateForm } = this.props
    const { email, username, password } = this.state
    e.preventDefault()
    this.setState({ loading: true })
    updateForm('email', email)

    if (this.validateErrors()) {
      return
    }
    this.checkForExistingEmail()

    if (this.validateErrors()) {
      return
    }
    const newUser = {
      email,
      password,
      username
    }
    axios
      .post(constants.api.auth.signup, {
        ...newUser,
        platform: 'web'
      })
      .then((res) => {
        if (res.data.success) {
          // local signup -> post local login and take access token and username
          axios
            .post(constants.api.auth.login, {
              email: newUser.email,
              password: newUser.password
            })
            .then((response) => {
              if (response.data.success) {
                updateForm('username', response.data.user.username)
                updateForm('token', response.data.token)
                axios.defaults.headers.common.Authorization = `bearer ${response.data.token}`
                Auth.initializeWith(response.data)
                setNextStep('form')
              }
            })
            .catch((error) => {
              console.error('error', error)
            })
        }
      })
      .catch((error) => console.error('error', error))
  }

  checkUsername(username) {
    const { errors } = this.state

    if (!username) {
      return
    }

    if (username && !/^[a-z0-9-]{1,20}$/.test(username)) {
      this.setState({
        ...errors,
        username: 'Up to 20 lowercase letters and numbers only'
      })
      return
    }

    this.setState({
      usernameChecked: 'checking',
      errors: { ...errors, username: '' }
    })
    axios
      .get(`${constants.api.auth.check}username/${username}`)
      .then((res) => {
        if (res.data) {
          this.setState({
            usernameChecked: 'taken',
            errors: {
              ...errors,
              username: 'That username is already taken'
            }
          })
        } else {
          this.setState({
            usernameChecked: 'available',
            errors: { ...errors, username: '' }
          })
        }
      })
      .catch((err) => {
        console.error(err)
        this.setState({ loading: false })
      })
  }

  handleChangeUsername(value) {
    const { errors } = this.state
    // dont allow special chars
    if (/^[a-zA-Z0-9-]{1,20}$/.test(value)) {
      const trimmed = value.trim().toLowerCase()
      this.setState({ username: trimmed })
      this.checkUsername(trimmed)
    } else if (!value) {
      this.setState({ username: '', errors: { ...errors, username: '' } })
    }
  }

  // TODO fix
  // eslint-disable-next-line sonarjs/cognitive-complexity,complexity
  render() {
    const {
      hidePassword,
      password,
      errors,
      focus,
      email,
      username,
      usernameChecked
    } = this.state
    return (
      <Container>
        <SubTitle>Sign up for an abillion account</SubTitle>
        <Form onSubmit={this.handleSubmit}>
          <Label htmlFor="username">Username</Label>
          <TextContainer
            error={username.length > 0 && errors.username}
            hasFocus={focus.username}
          >
            <TextInput
              type="text"
              name="username"
              placeholder="Lowercase letters and numbers only"
              value={username}
              onChange={(e) => {
                // this.checkUsername(e.target.value)
                this.handleChangeUsername(e.target.value)
              }}
            />
            <Icon>
              {!username.length && <Username />}
              {!!username.length && usernameChecked === 'checking' && (
                <PageLoadingCircularProgress size={20} />
              )}
              {!!username.length && usernameChecked === 'taken' && (
                <FormInputUnavailable />
              )}
              {!!username.length &&
                usernameChecked === 'available' &&
                username.length > 0 && <FormInputAvailable />}
            </Icon>
          </TextContainer>
          <ErrorDiv>{username.length > 0 && errors.username}</ErrorDiv>

          {usernameChecked === 'available' && (
            <ReferralCode
              code={username}
              marginBottom={styles.margin.small}
              marginTop={styles.margin.small}
            />
          )}

          <Label htmlFor="email">Email</Label>
          <TextContainer error={errors.email} hasFocus={focus.email}>
            <TextInput
              type="text"
              autoFocus
              name="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) =>
                this.handleChange('email', e.target.value.trim().toLowerCase())
              }
            />
          </TextContainer>
          <ErrorDiv>{errors.email}</ErrorDiv>
          <HorizontalContainer>
            <Label htmlFor="password">Password</Label>
            <ShowPassword type="button" onClick={this.toggleShowPassword}>
              {hidePassword ? 'Show password' : 'Hide password'}
            </ShowPassword>
          </HorizontalContainer>

          <TextContainer error={errors.password} hasFocus={focus.password}>
            <Password
              type={hidePassword ? 'password' : 'text'}
              value={password}
              name="password"
              onChange={(e) => this.handleChange('password', e.target.value)}
              placeholder="Minimum 8 characters"
            />
          </TextContainer>
          <ErrorDiv>{errors.password}</ErrorDiv>

          <Agree>
            By clicking Sign up, you acknowledge that you have read and agreed
            to our
            <a
              href="/policies/terms"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: colors.palette.primary.main }}
            >
              {' '}
              User Agreement
            </a>
            .
          </Agree>

          <LoginButton onClick={this.handleSubmit}>Sign up</LoginButton>
          <Text>
            Already have an account?&nbsp;
            <SignButton onClick={() => this.handleLogin('login')}>
              Log in
            </SignButton>
          </Text>
        </Form>
      </Container>
    )
  }
}

Signup.propTypes = {
  setNextStep: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => ({
  updateForm: (category, value) => {
    dispatch({ type: actions.UPDATE_FORM_AMBASSADOR, category, value })
  },
  setNextStep: (step) => {
    dispatch({ type: actions.SET_NEXT_STEP, step })
  }
})

export default connect(null, mapDispatchToProps)(Signup)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${styles.margin.large};
  padding: ${styles.padding.medium};
`

const SubTitle = styled.h2`
  color: ${styles.colors.darkGrey};
  margin: ${styles.margin.small};
  text-align: center;
  font-size: 1.5em;
`

const Text = styled.p`
  color: ${styles.colors.grey};
  width: 70%;
  font-size: 1em;
  text-align: center;
`

const Form = styled.form`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${styles.margin.small};
`

const HorizontalContainer = styled.div`
  justify-content: space-between;
  width: 100%;
  display: flex;
  flex-direction: row;
`
const Label = styled.p`
  color: ${styles.colors.darkGrey};
  text-align: left;
  font-size: 1em;
  width: 100%;
  margin: ${styles.margin.tiny};
  padding-left: ${styles.padding.small};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background-color: ${styles.colors.white};
  color: ${styles.colors.black};
  padding: 0 ${styles.padding.medium};
  border: 2px solid
    ${(props) =>
      // TODO fix
      // eslint-disable-next-line no-nested-ternary
      props.error
        ? styles.colors.action
        : props.hasFocus
        ? styles.colors.black
        : styles.colors.grey};
  border-radius: 50px;
  overflow: hidden;
`

const TextInput = styled.input`
  width: 100%;
  height: 40px;
  cursor: text;
  resize: none;
  white-space: normal;
  font-size: 1em;
  ::-webkit-input-placeholder {
    /* Chrome */
    color: ${styles.colors.salmon};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${styles.colors.salmon};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
  :-moz-placeholder {
    /* Firefox 4 - 18 */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
`

const ErrorDiv = styled.span`
  color: ${styles.colors.action};
  margin-top: ${styles.margin.small};
  font-size: 0.8em;
`

const Password = styled.input`
  cursor: text;
  height: 40px;
  font-size: 1em;
  white-space: normal;
  width: 100%;
  ::-webkit-input-placeholder {
    /* Chrome */
    color: ${styles.colors.salmon};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${styles.colors.salmon};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
  :-moz-placeholder {
    /* Firefox 4 - 18 */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
`

const LoginButton = styled.button`
  height: 40px;
  width: 100%;
  max-width: 400px;
  color: ${styles.colors.white};
  border-radius: 50px;
  font-size: 0.8em;
  margin: ${styles.margin.small};
  background-color: #7500cb;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    background-color: ${styles.colors.white};
    color: #7500cb;
    border: 2px solid #7500cb;
  }
`

const SignButton = styled.button`
  color: #7500cb;
  cursor: pointer;
  font-size: 1em;
`
const Icon = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ShowPassword = styled.button`
  color: ${styles.colors.facebook};
  font-size: 0.8em;
  width: 100%;
  text-align: right;
  cursor: pointer;
  margin-right: ${styles.margin.small};
`
const NoAccount = styled.div`
  width: 100%;
  max-width: 480px;
  font-size: 1.25em;
  padding: ${styles.padding.large} 0;
  font-weight: 100;
  text-align: center;
`
const Agree = styled(NoAccount)`
  font-size: 0.8em;
  font-weight: normal;
  color: ${styles.colors.darkGrey};
`
